export const formulierPageContainerClassName = "formulier-page-container formulier-page-container--opencak";
